import { AppMessageFactory } from './message/app-message.factory';
import { GLOBAL_MESSAGE_HANDLER_TOKEN } from './service/global-message-handler.token';
import { GlobalMessageHandlerService } from './service/message-handler.service';
import * as i0 from "@angular/core";
export let CoreMessagesModule = /*#__PURE__*/(() => {
  class CoreMessagesModule {
    static {
      this.ɵfac = function CoreMessagesModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreMessagesModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CoreMessagesModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [AppMessageFactory, {
          provide: GLOBAL_MESSAGE_HANDLER_TOKEN,
          useExisting: GlobalMessageHandlerService
        }]
      });
    }
  }
  return CoreMessagesModule;
})();